import { render } from "./Speaker.vue?vue&type=template&id=836070c8&scoped=true"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"

import "./Speaker.vue?vue&type=style&index=0&id=836070c8&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836070c8"]])

export default __exports__